
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-layout-line',
    title: 'Tabiques de pladur',
    description: 'Divisiones interiores rápidas y limpias para redistribuir espacios en viviendas, oficinas y locales comerciales.',
    link: '/servicios',
  },
  {
    icon: 'ri-building-line',
    title: 'Trasdosados',
    description: 'Directos y autoportantes con opciones de aislamiento térmico y acústico para mejorar el confort de tu hogar.',
    link: '/servicios',
  },
  {
    icon: 'ri-stack-line',
    title: 'Falsos techos',
    description: 'Techos continuos y registrables para ocultar instalaciones y mejorar la estética de cualquier espacio.',
    link: '/servicios',
  },
  {
    icon: 'ri-volume-mute-line',
    title: 'Aislamiento acústico',
    description: 'Soluciones de insonorización para reducir el ruido entre estancias y mejorar la privacidad.',
    link: '/servicios',
  },
  {
    icon: 'ri-temp-cold-line',
    title: 'Aislamiento térmico',
    description: 'Mejora la eficiencia energética de tu vivienda con sistemas de aislamiento de alta calidad.',
    link: '/servicios',
  },
  {
    icon: 'ri-drop-line',
    title: 'Pladur antihumedad',
    description: 'Placas especiales para baños, cocinas y lavaderos que resisten la humedad y evitan problemas futuros.',
    link: '/servicios',
  },
];

const ServicesSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section ref={ref} className="py-24 bg-dark-card">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="inline-block px-4 py-2 bg-orange-primary/10 border border-orange-primary rounded-full mb-6"
          >
            <span className="text-orange-primary text-sm font-bold">Nuestros servicios</span>
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-4xl md:text-5xl font-extrabold text-text-primary mb-6"
          >
            Soluciones completas en pladur
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="text-text-secondary text-lg max-w-2xl mx-auto"
          >
            Ofrecemos servicios profesionales de instalación de pladur en Badalona para todo tipo de proyectos
          </motion.p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.1 * index }}
              className="group"
            >
              <Link
                to={service.link}
                className="block bg-dark-bg border border-dark-border rounded-2xl p-10 hover:-translate-y-2 transition-all duration-300 hover:border-orange-primary hover:shadow-glow-orange-lg h-full"
              >
                {/* Icon */}
                <div className="w-20 h-20 bg-gradient-to-br from-orange-primary to-orange-secondary rounded-2xl flex items-center justify-center mb-6 group-hover:rotate-6 transition-transform duration-300">
                  <i className={`${service.icon} text-white text-3xl`}></i>
                </div>

                {/* Title */}
                <h3 className="text-2xl font-bold text-text-primary mb-4 group-hover:text-orange-primary transition-colors duration-300">
                  {service.title}
                </h3>

                {/* Description */}
                <p className="text-text-muted text-base leading-relaxed mb-6">
                  {service.description}
                </p>

                {/* Link */}
                <div className="flex items-center space-x-2 text-orange-primary font-medium">
                  <span>Ver más</span>
                  <i className="ri-arrow-right-line group-hover:translate-x-2 transition-transform duration-300"></i>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
